var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.7082H5.83332C2.79166 17.7082 1.04166 15.9582 1.04166 12.9165V7.08317C1.04166 4.0415 2.79166 2.2915 5.83332 2.2915H14.1667C17.2083 2.2915 18.9583 4.0415 18.9583 7.08317V12.9165C18.9583 15.9582 17.2083 17.7082 14.1667 17.7082ZM5.83332 3.5415C3.44999 3.5415 2.29166 4.69984 2.29166 7.08317V12.9165C2.29166 15.2998 3.44999 16.4582 5.83332 16.4582H14.1667C16.55 16.4582 17.7083 15.2998 17.7083 12.9165V7.08317C17.7083 4.69984 16.55 3.5415 14.1667 3.5415H5.83332Z",
    fill: "#526477"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99983 10.725C9.29982 10.725 8.59149 10.5083 8.04983 10.0666L5.44149 7.98331C5.17482 7.76664 5.12483 7.37497 5.34149 7.10831C5.55816 6.84164 5.94983 6.79164 6.2165 7.00831L8.82482 9.09164C9.45816 9.59998 10.5332 9.59998 11.1665 9.09164L13.7748 7.00831C14.0415 6.79164 14.4415 6.83331 14.6498 7.10831C14.8665 7.37497 14.8248 7.77498 14.5498 7.98331L11.9415 10.0666C11.4082 10.5083 10.6998 10.725 9.99983 10.725Z",
    fill: "#526477"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.c4cd6b1ab4a5c1eddee4586dbed6130f.svg";
export { ForwardRef as ReactComponent };